import Dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';

Dayjs.extend(utc);
Dayjs.extend(relativeTime);

export const getTimeFromNow = (pastTime: string) => {
  const time = Dayjs(pastTime)?.add(Dayjs(pastTime)?.utcOffset(), 'minute');
  const now = Dayjs();
  return time?.from(now);
};
